// extracted by mini-css-extract-plugin
export var downArrow = "_ff-0";
export var infoTooltipIcon = "_ff-3";
export var label = "_ff-1";
export var optionCard = "_ff-4";
export var upArrow = "_ff-2";